import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { ProvidersService } from '../../services/providers.service';
import { saveAs } from 'file-saver/FileSaver';
import { TranslateService } from 'ng2-translate';


@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent implements OnInit {
  userId: any;
  userToken: any;
  textButton: any;
  loadBtn = false;
  type: any;
  info: any = {};
  editId: any;
  numOrder: any;
  txtHeader: any;
  msgInvoice: any;
  dataCharges: any = {};
  listCharges = [];
  approvation:false;
  rejectedStep=1;
  userid:any;
  btnAprobacionExtranjero:any = 'false';

  isAvailable = false;
  headers = "Purcharse Order";

  constructor(private translate: TranslateService,private toastr: ToastrService, private gralService: GeneralService, private provService: ProvidersService, public dialog: MatDialog, public dialogRef: MatDialogRef<OrderDetailComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.type = this.data.type;
    this.numOrder = this.data.oc;
    this.editId = this.data.id;
    this.approvation = this.data.approve;
    this.userid =  this.data.userId;
    if(this.data.kind == "55"){
      if(this.translate.currentLang == "es"){
        this.headers = "Ordenes abiertas 55";
      }else if(this.translate.currentLang == "en"){
        this.headers = "Scheduling agreement 55";
      }
    }
    if(this.data.kind == "45"){
      if(this.translate.currentLang == "es"){
        this.headers = "Ordenes cerradas 45";
      }else if(this.translate.currentLang == "en"){
        this.headers = "Purchase order 45";
      }
    }

    console.log("this.approvation %0", this.approvation);
    if(this.type == 'detail'){
      this.rejectedStep = 0;
      this.btnAprobacionExtranjero = localStorage.getItem('btnAprobacionExtranjero');
    } 
    if(this.type == 'detail' || this.type == 'detailConsigment' ){
      this.info = this.data.info;
      console.log(this.info.RecepcionFactura.EstatusProcesoFactura.Descripcion);
      this.txtHeader = 'DETAILS';
    }
    console.log(this.info)

    //this.isAvailable = (this.info.RecepcionFactura.IdTipoOrden == 3)?true:false;
    if(this.type == 'extraCharges'){
      this.txtHeader = 'EXTRACHARGES';
    }
    this.msgInvoice = this.info.Resultado.Miromensaje;
    console.log(" RFC Extranjero "+this.info.RecepcionFactura.RFCEmisor );
    if(this.info.RecepcionFactura.RFCEmisor == 'XEXX010101000'){
      if(this.info.Resultado.Miromensaje.includes('UUID') /*this.info.RecepcionFactura.EstatusProcesoFactura.IdCatEstatusProcesoFactura == 4 || this.info.RecepcionFactura.EstatusProcesoFactura.IdCatEstatusProcesoFactura == 13 || this.info.RecepcionFactura.EstatusProcesoFactura.IdCatEstatusProcesoFactura == 12*/){
        console.log(" if includes uuid ");
        this.msgInvoice = "Se validaron los datos capturados|Se guardó correctamente la factura PDF y los datos correspondientes|La información se guardó|El proceso de recepción pasa al estatus de registrar la factura a SAP y se le notificará a su correo electrónico.";
        if(this.translate.currentLang == "es"){
          this.msgInvoice = "Se validaron los datos capturados|Se guardó correctamente la factura PDF y los datos correspondientes|La información se guardó|El proceso de recepción pasa al estatus de registrar la factura a SAP y se le notificará a su correo electrónico."
        }else if(this.translate.currentLang == "en"){
          this.msgInvoice = "The captured data was validated | The PDF invoice and the corresponding data were saved correctly | The information was saved | The reception process goes to the status of registering the invoice to SAP and you will be notified by email."
        }
        
      }else if(this.info.RecepcionFactura.EstatusProcesoFactura.IdCatEstatusProcesoFactura == 5){
        this.msgInvoice = this.info.Resultado.Miromensaje;
      } 
        
    }
    if(this.msgInvoice == "ERROR-No se encontraron recepciones relacionados a la operación."){
      this.msgInvoice = "ERROR-No se encontraron recepciones relacionados a la operación.";
      if(this.translate.currentLang == "es"){
        this.msgInvoice = "ERROR-No se encontraron recepciones relacionados a la operación.";
      }else if(this.translate.currentLang == "en"){
        this.msgInvoice = "ERROR-No receptions related to the operation were found.";
      }
    }
  }

  ngOnInit() {
  }

  onCloseConfirm() {
    this.dialogRef.close({ data: true });
  }

  onCloseCancel() {

    console.log('click para cerrar')
    this.dialogRef.close();
  }

  addCharge(){
    if(!this.dataCharges.descripcion ||  !this.dataCharges.importe ){
      let body = "Favor de ingresar todos los campos";
      if(this.translate.currentLang == "es"){
        body = "Favor de ingresar todos los campos";
      }else if(this.translate.currentLang == "en"){
        body = "Please enter all fields";
      }
      this.toastr.error(body, 'Error');
      return;
    }

    this.dataCharges.no = this.listCharges.length+1;
    this.listCharges.push(this.dataCharges);
    this.dataCharges = {};
  }

  charges(){
    console.log(this.listCharges);
    this.dialogRef.close({ listCharges: this.listCharges });
  }

  downLoadFile(){
    this.editId
    this.provService.downloadFiles(this.editId, '').then((res:any)=>{
      this.loadBtn = false;
      console.log(res.resultado.Entidad );
      if(res.resultado){


        if(res.Entidad.esPdf || res.Entidad.esXml ){
          const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
          const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });

          let mimeType;
          if(!res.Entidad.esZip){
            mimeType = (res.Entidad.esPdf)?'.pdf': '.xml';
          }else{
            mimeType =  '.zip';
          }

          let fileName= Date.now();
          let tempName = fileName+mimeType;

          saveAs(blob, tempName);
        }
      }

    })
    // let file = event.target.files[0];


    // let reader = new FileReader();
    // if(event.target.files && event.target.files.length > 0) {
    //   let file = event.target.files[0];
    //   reader.readAsDataURL(file);
    //   reader.onload = () => {

    //     let base64Image = 'data:'+ file.type +';base64,'+reader.result.split(',')[1];
    //     //this.imagenGrupoPrivado = base64Image;

    //   };
    // }



  }

  download(id, idx){
    console.log(id, idx);
    this.provService.downloadHistoryComplement(id, this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      console.log(data);
      if(data['respuestaExitosa']){
        const sampleBytes = this.base64ToArrayBuffer(data['File'].FileContent);
        const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
        saveAs(blob, data['File'].FileName);
      }else{
        let title = "Descargar historial";
        let body = "No se puede descargar el archivo";
        if(this.translate.currentLang == "es"){
          title = "Descargar historial";
          body = "No se puede descargar el archivo";
        }else if(this.translate.currentLang == "en"){
          body = "Unable to download file";
          title = "Download history";
        }
        this.toastr.info(body,title);
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      let title = "Descargar historial";
      let body = "No se puede descargar el archivo";
      if(this.translate.currentLang == "es"){
        title = "Descargar historial";
        body = "No se puede descargar el archivo";
      }else if(this.translate.currentLang == "en"){
        body = "Unable to download file";
        title = "Download history";
      }
      this.toastr.info(body,title);
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  base64ToArrayBuffer(base64) {
    const binaryString =  window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++)        {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  removeItem(position){
    this.listCharges.splice(position, 1);
  }

  aprobation:any={};

  rejectedInvoice(){
    this.aprobation.Aprobar = false;
    this.rejectedStep=2;
  }

  approve(){
    this.aprobation.Aprobar = true;
    this.saveAprobation();
  }

  saveAprobation(){
    this.aprobation.IdUsuario = this.userid;
    this.aprobation.GuidRecepcionFactura = this.editId;
    this.provService.approveInvoice(this.aprobation, '123').then((res:any)=>{
      if(res.EsValido){
        this.dialogRef.close({ data: true });
      }else{
        this.toastr.error(res.MensajeUsuario ,'Error');
      }
    });
  }

  downloadDetail(fieldUUID){
    //let fieldUUID = this.listOrders[pos].RecepcionFactura.UUID;

    this.provService.downloadFiles( fieldUUID,'111').then((res:any) => {

      if(res.resultado){
        if(res.Entidad.esPdf || res.Entidad.esXml ){
          const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
          const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });

          let mimeType;
          if(!res.Entidad.esZip){
            mimeType = (res.Entidad.esPdf)?'.pdf': '.xml';
          }else{
            mimeType =  '.zip';
          }

          let fileName= Date.now();
          let tempName = fileName+mimeType;
          console.log(tempName);
          saveAs(blob, tempName);
        }else{
          const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
          const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
          let mimeType =  '.zip';

          let fileName= Date.now();
          let tempName = fileName+mimeType;
          console.log(tempName);
          saveAs(blob, tempName);
        }
      }
    });
  }
}
